module.exports = __webpack_public_path__ + "assets/0c420ab58ee978ad0200279426ab64aa.png";